import styled from 'styled-components'
import { grid, GridProps, width, WidthProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps>`
  display: grid;
  padding-block: ${themeGet('space.11')}px;
  gap: ${themeGet('space.11')}px;

  ${grid}
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
`

export const ImageHolder = styled.div.withConfig({
  shouldForwardProp,
})<WidthProps>`
  display: flex;

  img {
    object-fit: cover;
    height: 100%;
    width: 100%;
  }

  ${width}
`
